"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchFunction = getFetchFunction;
exports.fetchInitialFiles = fetchInitialFiles;
exports.fetchMoreFiles = fetchMoreFiles;
exports.setPanel = setPanel;
exports.enterSearchPanel = enterSearchPanel;
exports.goBack = goBack;
exports.setSearchQuery = setSearchQuery;
exports.deselectFile = deselectFile;
exports.updateDetailHeight = updateDetailHeight;
exports.navigatorDidMount = exports.maybeFetchFoldersByParentId = exports.maybeFetchFolders = exports.libComponentDidMount = exports.returnToPrevious = exports.handleInsertFile = exports.selectFile = exports.recalculateImageDimensionsIfNeeded = exports.browseToFolder = exports.trackInteraction = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = _interopRequireDefault(require("immutable"));

var _Constants = require("FileManagerCore/Constants");

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var FilesApi = _interopRequireWildcard(require("FileManagerCore/api/Files"));

var _Suspension = require("FileManagerCore/actions/Suspension");

var _Files2 = require("FileManagerCore/actions/Files");

var _FolderFetch = require("FileManagerCore/actions/FolderFetch");

var _image = require("FileManagerCore/utils/image");

var _logging = require("FileManagerCore/utils/logging");

var trackingActions = _interopRequireWildcard(require("FileManagerCore/actions/tracking"));

var _FileSearch = require("FileManagerCore/actions/FileSearch");

var _FileDetails = require("FileManagerCore/actions/FileDetails");

var _file = require("FileManagerCore/utils/file");

var _Auth = require("FileManagerCore/selectors/Auth");

var _Files3 = require("FileManagerCore/selectors/Files");

var _Folders = require("FileManagerCore/selectors/Folders");

var _PortalMeta = require("FileManagerCore/selectors/PortalMeta");

var _PortalMeta2 = require("FileManagerCore/actions/PortalMeta");

var _Limits = require("FileManagerCore/actions/Limits");

var _UserSettings = require("FileManagerCore/actions/UserSettings");

var _UserSettings2 = require("FileManagerCore/selectors/UserSettings");

var _fileAccessibility = require("FileManagerCore/utils/fileAccessibility");

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var _ActionTypes2 = require("./ActionTypes");

var _Constants2 = require("../Constants");

var _Configuration = require("../selectors/Configuration");

var _Panel = require("../selectors/Panel");

var _ImageOptimizationSettings = require("../selectors/ImageOptimizationSettings");

var ImageOptimizationSettings = _interopRequireWildcard(require("../enums/ImageOptimizationSettings"));

var _getIsFileOptimizableImage = _interopRequireDefault(require("../utils/getIsFileOptimizableImage"));

var _getOptimizedImage = _interopRequireDefault(require("../utils/getOptimizedImage"));

var _overrideFileUrls = _interopRequireDefault(require("../utils/overrideFileUrls"));

// todo - move all the references to this core action
var trackInteraction = trackingActions.trackInteraction;
exports.trackInteraction = trackInteraction;

var DEFAULT_QUERY = _immutable.default.Map({
  order_by: '-updated'
});

function getFilesQuery() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var query = DEFAULT_QUERY.merge(options);

  switch (query.get('type')) {
    case _Constants2.DrawerTypes.IMAGE:
      return query.set('type', _Constants.FileTypes.IMG);

    case _Constants2.DrawerTypes.VIDEO:
    case _Constants2.DrawerTypes.HUBL_VIDEO:
      return query.set('type', _Constants.FileTypes.MOVIE);

    case _Constants2.DrawerTypes.DOCUMENT:
      return query.set('type', _Constants.FileTypes.DOCUMENT);

    case _Constants2.DrawerTypes.FILE:
    default:
      return query.delete('type');
  }
}

function getFetchFunction(drawerType) {
  if (drawerType === _Constants2.DrawerTypes.HUBL_VIDEO) {
    return FilesApi.fetchIntegratedVideos;
  }

  return FilesApi.fetchFiles;
}

function fetchInitialFiles() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var drawerType = arguments.length > 1 ? arguments[1] : undefined;
  return function (dispatch, getState, httpClient) {
    var query = getFilesQuery(options);
    query = query.set('hostApp', (0, _Configuration.getHostApp)(getState()));

    if ((0, _Configuration.getUseEsFileSearch)(getState()) && drawerType !== _Constants2.DrawerTypes.HUBL_VIDEO) {
      dispatch((0, _FileSearch.searchFiles)(query.toJS()));
      return;
    }

    var fetchFunction = getFetchFunction(drawerType);
    dispatch((0, _Files2.attemptFilesFetch)(query));
    fetchFunction(query, httpClient).then(function (data) {
      dispatch((0, _Files2.receiveFilesFetch)(query, data));
    }, function (error) {
      (0, _logging.reportError)(error, {
        action: _ActionTypes.FETCH_FILES_FAILED
      });
      dispatch((0, _Files2.failFilesFetch)(query, error));
    }).done();
  };
}

function fetchMoreFiles() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var drawerType = arguments.length > 1 ? arguments[1] : undefined;
  return function (dispatch, getState, httpClient) {
    var fetchFunction = getFetchFunction(drawerType);
    var query = getFilesQuery(options);
    query = query.set('hostApp', (0, _Configuration.getHostApp)(getState()));

    if ((0, _Configuration.getUseEsFileSearch)(getState()) && drawerType !== _Constants2.DrawerTypes.HUBL_VIDEO) {
      dispatch((0, _FileSearch.searchFiles)(query.toJS(), true));
      return;
    }

    dispatch({
      type: _ActionTypes.FETCH_MORE_FILES_ATTEMPTED,
      query: query
    });
    fetchFunction(query, httpClient).then(function (data) {
      dispatch({
        type: _ActionTypes.FETCH_MORE_FILES_SUCCEEDED,
        query: query,
        data: data
      });
    }).done();
  };
}

function setPanel(_ref) {
  var activePanel = _ref.activePanel,
      selectedFolder = _ref.selectedFolder,
      searchQuery = _ref.searchQuery;
  return {
    type: _ActionTypes2.SET_PANEL,
    activePanel: activePanel,
    selectedFolder: selectedFolder,
    searchQuery: searchQuery,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: 'Explore Files',
      eventKey: 'fileManagerSetPanelExploreFiles',
      action: 'set-panel',
      meta: {
        panel: _Constants2.TrackingPanelLabels[activePanel]
      }
    })
  };
}

var browseToFolder = function browseToFolder(folderId) {
  return function (dispatch, getState) {
    if (folderId && (0, _Files3.getIsSearching)(getState())) {
      dispatch((0, _FolderFetch.fetchFolderById)(folderId, {
        withBreadcrumbs: true
      }));
    }

    var folder = (0, _Folders.getFoldersById)(getState()).get(folderId) || (0, _FoldersAndFiles.getHomeFolder)();
    dispatch(setPanel({
      activePanel: _Constants2.Panels.FOLDER,
      selectedFolder: folder
    }));
  };
};

exports.browseToFolder = browseToFolder;

function enterSearchPanel(searchQuery) {
  return {
    type: _ActionTypes2.SET_PANEL,
    activePanel: _Constants2.Panels.SEARCH,
    selectedFolder: null,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: 'Explore Files',
      eventKey: 'fileManagerExploreFiles',
      action: 'started-search'
    }),
    searchQuery: searchQuery
  };
}

function goBack() {
  return {
    type: _ActionTypes2.BACK,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: 'Explore Files',
      eventKey: 'fileManagerExploreFiles',
      action: 'back'
    })
  };
}

function setSearchQuery(searchQuery) {
  return {
    type: _ActionTypes2.SEARCH,
    searchQuery: searchQuery
  };
}

function getSelectFileAction(selectedFile, meta) {
  return {
    type: _ActionTypes2.SELECT_FILE,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: 'Explore Files',
      eventKey: 'fileManagerExploreFiles',
      action: 'select-file',
      fileType: (0, _file.getType)(selectedFile.get('extension')),
      meta: Object.assign({}, meta, {
        fileType: (0, _file.getType)(selectedFile.get('extension'))
      })
    }),
    selectedFile: selectedFile
  };
}

var recalculateImageDimensionsIfNeeded = function recalculateImageDimensionsIfNeeded(file) {
  return function (dispatch, getState) {
    if (!(0, _Auth.getIsUngatedForRecalculateImageDimensions)(getState()) || !(0, _image.shouldRecalculateDimensions)(file)) {
      return Promise.resolve(file);
    }

    var fileId = file.get('id');
    return FilesApi.recalculateImageDimensions(fileId).then(function (fileResp) {
      dispatch({
        type: _ActionTypes.RECALCULATE_IMAGE_DIMENSIONS_SUCCESS,
        file: fileResp
      });

      if (!(0, _image.hasDimensions)(fileResp)) {
        (0, _logging.reportMessage)('Image still missing dimensions after recalculating', {
          fileId: fileId,
          type: 'RECALCULATE_IMAGE_DIMENSIONS'
        });
      }

      return fileResp;
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        type: 'RECALCULATE_IMAGE_DIMENSIONS'
      });
      return file;
    });
  };
};

exports.recalculateImageDimensionsIfNeeded = recalculateImageDimensionsIfNeeded;

var selectFile = function selectFile(selectedFile) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    dispatch((0, _FileDetails.fetchSingleFileIfNeeded)(selectedFile.get('id'))).then(function (singleFile) {
      return dispatch(recalculateImageDimensionsIfNeeded(singleFile));
    }).done();
    dispatch(getSelectFileAction(selectedFile, meta));
  };
};

exports.selectFile = selectFile;

var optimizeFileAndCallOnSelect = function optimizeFileAndCallOnSelect(file, onSelectCallback) {
  return function (dispatch, getState) {
    var imageOptimizationSetting = (0, _ImageOptimizationSettings.getImageOptimizationSetting)(getState());

    if (imageOptimizationSetting !== ImageOptimizationSettings.MEDIUM && (0, _getIsFileOptimizableImage.default)(file)) {
      onSelectCallback((0, _getOptimizedImage.default)(file, imageOptimizationSetting));
    } else {
      onSelectCallback(file);
    }
  };
};

var handleDispatchCallback = function handleDispatchCallback(file, onSelectCallback) {
  return function (dispatch) {
    var isFilePrivate = (0, _fileAccessibility.getIsFilePrivate)(file);

    if (isFilePrivate) {
      file = (0, _overrideFileUrls.default)(file, FilesApi.getSignedUrlRedirectViewUrl(file.get('id')));
      onSelectCallback(file);
    } else {
      dispatch(optimizeFileAndCallOnSelect(file, onSelectCallback));
    }
  };
};

var handleInsertFile = function handleInsertFile(file, onSelectCallback) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      type = _ref2.type,
      target = _ref2.target,
      withPanelNavigator = _ref2.withPanelNavigator;

  return function (dispatch) {
    if ((0, _file.getIsTemporaryUploadingFile)(file)) {
      onSelectCallback(file);
    } else {
      dispatch((0, _FileDetails.fetchSingleFileIfNeeded)(file.get('id'))).then(function (singleFile) {
        return dispatch(recalculateImageDimensionsIfNeeded(singleFile));
      }).then(function (singleFile) {
        dispatch(handleDispatchCallback(singleFile, onSelectCallback));
      }).done();
    }

    var trackingAttrs = {
      target: target,
      drawerType: type,
      withPanelNavigator: withPanelNavigator
    };

    if (type === _Constants2.DrawerTypes.HUBL_VIDEO) {
      dispatch(trackInteraction('Manage Files', 'insert-hubl-video', trackingAttrs));
    } else {
      dispatch(trackInteraction('Manage Files', 'insert', trackingAttrs));
    }
  };
};

exports.handleInsertFile = handleInsertFile;

function deselectFile() {
  var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: _ActionTypes2.SELECT_FILE,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: 'Explore Files',
      eventKey: 'fileManagerExploreFiles',
      action: 'deselect-file',
      meta: meta
    }),
    selectedFile: null
  };
}

var clearHistory = function clearHistory() {
  return {
    type: _ActionTypes2.CLEAR_HISTORY
  };
};

var returnToPrevious = function returnToPrevious() {
  return function (dispatch, getState) {
    var previousPanel = (0, _Panel.getPreviousPanel)(getState());
    var selectedFileId = (0, _Panel.getSelectedFileId)(getState());
    var selectedFolder = (0, _Panel.getSelectedFolderInPanel)(getState());
    var isBrowsingHomeFolder = Boolean(selectedFolder && !selectedFolder.get('id'));

    if (selectedFileId) {
      dispatch(deselectFile({
        target: 'panel-navigator-previous'
      }));
    } else if (isBrowsingHomeFolder && previousPanel.get('activePanel') !== _Constants2.Panels.BROWSE) {
      dispatch(clearHistory());
    } else if (previousPanel) {
      dispatch(goBack());
    } else {
      dispatch(clearHistory());
    }
  };
};

exports.returnToPrevious = returnToPrevious;
var PANELS_TO_UNSET_ON_MOUNT = [_Constants2.Panels.FROM_URL, _Constants2.Panels.BULK_IMPORT_FROM_URL];

var libComponentDidMount = function libComponentDidMount() {
  return function (dispatch, getState) {
    if ((0, _Auth.getUser)(getState()) && !(0, _Auth.getHasFileManagerWriteScope)(getState())) {
      dispatch((0, _Suspension.fetchSuspensionStatus)());
    }

    if (PANELS_TO_UNSET_ON_MOUNT.includes((0, _Panel.getActivePanel)(getState()))) {
      dispatch(clearHistory());
    }
  };
};

exports.libComponentDidMount = libComponentDidMount;

var maybeFetchFolders = function maybeFetchFolders() {
  return function (dispatch) {
    dispatch((0, _FolderFetch.fetchFoldersByParentId)(_Constants.ROOT_FOLDER_ID, {
      initialFetch: true
    }));
  };
};

exports.maybeFetchFolders = maybeFetchFolders;

var maybeFetchFoldersByParentId = function maybeFetchFoldersByParentId(parentFolderId) {
  return function (dispatch) {
    dispatch((0, _FolderFetch.fetchFoldersByParentId)(parentFolderId));
  };
};

exports.maybeFetchFoldersByParentId = maybeFetchFoldersByParentId;

var navigatorDidMount = function navigatorDidMount(type) {
  return function (dispatch, getState) {
    var state = getState();

    if (!(0, _PortalMeta.hasFetchedPortalMeta)(state)) {
      dispatch((0, _PortalMeta2.fetchFileManagerPortalData)());
    }

    if (type === _Constants2.DrawerTypes.HUBL_VIDEO && (0, _Auth.getHasVideoIntegrationScope)(state)) {
      dispatch((0, _Limits.fetchLimits)());
    } else if (type === _Constants2.DrawerTypes.IMAGE && !(0, _UserSettings2.getUserSettingsHaveLoaded)(state)) {
      dispatch((0, _UserSettings.fetchUserSettings)((0, _Auth.getUserId)(state)));
    }

    dispatch(trackInteraction('fileManagerLib', 'mount', {
      componentName: 'FilePickerPanel',
      drawerType: type,
      withPanelNavigator: true
    }));
  };
};

exports.navigatorDidMount = navigatorDidMount;

function updateDetailHeight(file, height) {
  return {
    type: _ActionTypes2.UPDATE_DETAIL_HEIGHT,
    file: file,
    height: height
  };
}